export default __webpack_public_path__ + "static/media/musicadd.439584a0.jpg";